import { i as isEmpty_1 } from './isEmpty-ea893565.js';
import { V as VIEW_ONLINE, O as ONLINE_VIEW } from './analytics-b3108572.js';
import './currency-49e0d692.js';

const columnTypes = {
    VERSIONS: 'versions',
    OS: 'os',
    LANGUAGE: 'language',
    FORMAT: 'format',
    SIZE: 'size',
    DATE: 'date',
    LINK: 'link',
    ONLINELINK: 'onlineLink',
};

const softwareDocumentsColumns = (productSoftwareInfo) => {
  if (!productSoftwareInfo) {
    return [];
  }
  return [
    {
      label: productSoftwareInfo.availableVersionsLabel,
      type: columnTypes.VERSIONS,
    },
    {
      label: productSoftwareInfo.operatingSystemsLabel,
      type: columnTypes.OS,
    },
    {
      label: productSoftwareInfo.languageLabel,
      type: columnTypes.LANGUAGE,
    },
    {
      label: productSoftwareInfo.formatLabel,
      type: columnTypes.FORMAT,
    },
    {
      label: productSoftwareInfo.sizeLabel,
      type: columnTypes.SIZE,
    },
    {
      label: productSoftwareInfo.dateLabel,
      type: columnTypes.DATE,
    },
  ];
};
const softwareDocumentsData = (productSoftwareInfo) => {
  if (isEmpty_1(productSoftwareInfo)) {
    return [];
  }
  return productSoftwareInfo.softwareDocuments.reduce((result, document) => {
    const { date, format, language, link, os, size, title, version, documentReference, documentName, documentType, downloadAll, files, } = document;
    return [
      ...result,
      {
        link,
        fileType: format,
        documentReference,
        documentName,
        documentType,
        downloadAll,
        files,
        cells: [
          {
            text: `${title !== null && title !== void 0 ? title : ''}${version ? ` (${productSoftwareInfo.versionLabel} ${version})` : ''}`,
            type: columnTypes.VERSIONS,
          },
          {
            text: os,
            mobileLabel: productSoftwareInfo.operatingSystemsLabel,
            type: columnTypes.OS,
          },
          {
            text: language,
            mobileLabel: productSoftwareInfo.languageLabel,
            type: columnTypes.LANGUAGE,
          },
          {
            text: format,
            type: columnTypes.FORMAT,
          },
          {
            text: size,
            type: columnTypes.SIZE,
          },
          {
            text: date,
            type: columnTypes.DATE,
          },
        ],
      },
    ];
  }, []);
};
const additionalInfoData = (productSoftwareInfo) => {
  const doc = productSoftwareInfo.softwareDocuments[0];
  const { availableVersionsLabel, operatingSystemsLabel, languageLabel, formatLabel, sizeLabel, dateLabel, versionLabel, } = productSoftwareInfo;
  return {
    title: doc.title,
    version: doc.version,
    labels: {
      availableVersionsLabel,
      operatingSystemsLabel,
      languageLabel,
      formatLabel,
      sizeLabel,
      dateLabel,
      versionLabel,
    },
    os: doc.os,
    format: doc.format,
    size: doc.size,
    date: doc.date,
    language: doc.language,
  };
};
const isViewOnline = (documentName) => {
  return documentName === VIEW_ONLINE || documentName === ONLINE_VIEW;
};
const getDownloadButtonLabel = (softwareDocuments, button, downloadLabel) => {
  var _a;
  if (isEmpty_1(button)) {
    return null;
  }
  const { onlineLabel, areaLabel } = button.labels;
  if ((softwareDocuments === null || softwareDocuments === void 0 ? void 0 : softwareDocuments.length) > 1) {
    return areaLabel;
  }
  if ((softwareDocuments === null || softwareDocuments === void 0 ? void 0 : softwareDocuments.length) === 1) {
    const { documentName, files, downloadAll } = softwareDocuments[0];
    const hasOnlineView = isViewOnline(documentName);
    const hasDownloadLink = downloadAll || (files && ((_a = files[0]) === null || _a === void 0 ? void 0 : _a.link));
    if (hasOnlineView && hasDownloadLink) {
      return areaLabel;
    }
    return hasOnlineView ? onlineLabel : downloadLabel;
  }
};
const getDownloadButtonIcon = (softwareDocuments) => {
  var _a;
  if ((softwareDocuments === null || softwareDocuments === void 0 ? void 0 : softwareDocuments.length) > 1) {
    return "square-behind-another";
  }
  if ((softwareDocuments === null || softwareDocuments === void 0 ? void 0 : softwareDocuments.length) === 1) {
    const { documentName, files, downloadAll } = softwareDocuments[0];
    const hasOnlineView = isViewOnline(documentName);
    const hasDownloadLink = downloadAll || (files && ((_a = files[0]) === null || _a === void 0 ? void 0 : _a.link));
    if (hasOnlineView && hasDownloadLink) {
      return "square-behind-another";
    }
    return hasOnlineView ? "arrow-top-right-on-square" : "arrow-down-tray";
  }
};

export { softwareDocumentsData as a, getDownloadButtonIcon as b, additionalInfoData as c, columnTypes as d, getDownloadButtonLabel as g, isViewOnline as i, softwareDocumentsColumns as s };
